/**
 * Cryptographically secure float in [0, 1).
 * Use for security-relevant values (IDs, tokens, nonces, secret shuffles, retry
 * jitter adjacent to crypto flows). Prefer {@link randomId} when you need an ID.
 */
export function secureRandom(): number {
  const buf = new Uint32Array(1)
  globalThis.crypto.getRandomValues(buf)
  // Divide by 2^32 so the result is in [0, 1), matching Math.random()'s range.
  return buf[0] / 0x1_0000_0000
}

/**
 * Non-cryptographic float in [0, 1).
 * Use only for cosmetic/UI randomness (animation jitter, decorative seeds,
 * random copy). All intentional `Math.random` usage in the Electron app should
 * go through this helper so SonarQube S2245 has a single reviewed call site.
 */
export function unsecureRandom(): number {
  return Math.random() // NOSONAR -- S2245: intentional non-CSPRNG; cosmetic use only
}

/**
 * Cryptographically secure random UUID (v4).
 * Prefer this over `*.toString(36)` ID generators.
 */
export function randomId(): string {
  return globalThis.crypto.randomUUID()
}
